Ext.define('SA.view.sidebar.data.ResultCountMessage', {
    alias: 'widget.result-count-message',
    extend: 'Ext.Component',

    cls: 'sa-result-count-message',

    tpl: [
        '<tpl if="count === 1">',
            '1 result for',
        '<tpl else>',
            '{count} results for',
        '</tpl>'
    ],

    refresh({hasConditions, count}) {
        this.setVisible(hasConditions).update({count});
    }
});